module.exports = __webpack_public_path__ + "static/media/up-arrow.96af5d6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/up-arrow.svg
// module id = 956
// module chunks = 0